import { render, staticRenderFns } from "./ProductsListDialog.vue?vue&type=template&id=18ae6e31&scoped=true"
import script from "./ProductsListDialog.vue?vue&type=script&lang=js"
export * from "./ProductsListDialog.vue?vue&type=script&lang=js"
import style0 from "./ProductsListDialog.vue?vue&type=style&index=0&id=18ae6e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ae6e31",
  null
  
)

export default component.exports